/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ContinueTransitionHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler 
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ContinueTransitionHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this,com.inq.flash.client.data.MessageFields.TYPE_CONTINUE_TRANSITION);
};
$hxClasses['com.inq.flash.client.control.messagehandlers.ContinueTransitionHandler'] = com.inq.flash.client.control.messagehandlers.ContinueTransitionHandler;
/** @private @type {Array} */
com.inq.flash.client.control.messagehandlers.ContinueTransitionHandler.__name__ = ["com","inq","flash","client","control","messagehandlers","ContinueTransitionHandler"];
/** @private @type {Function} */
com.inq.flash.client.control.messagehandlers.ContinueTransitionHandler.__super__ = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler;
for(var k in com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype ) com.inq.flash.client.control.messagehandlers.ContinueTransitionHandler.prototype[k] = com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.prototype[k];

/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * override public function processMessage(message:Message):Void
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ContinueTransitionHandler
 * @param {com.inq.flash.messagingframework.Message}  message 
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ContinueTransitionHandler.prototype.processMessage = function(message) {
	this.getController().acknowledgeChatActive();
};

/** @type {com.inq.flash.client.control.messagehandlers.ContinueTransitionHandler} */
com.inq.flash.client.control.messagehandlers.ContinueTransitionHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ContinueTransitionHandler;
